import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_googlegtag_7b8a2475 from 'nuxt_plugin_googlegtag_7b8a2475' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_pluginclient_e471faa8 from 'nuxt_plugin_pluginclient_e471faa8' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_18ff1798 from 'nuxt_plugin_pluginserver_18ff1798' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_screenDetect_4bb1ca16 from 'nuxt_plugin_screenDetect_4bb1ca16' // Source: ../plugins/screenDetect (mode: 'all')
import nuxt_plugin_polyFill_b2245196 from 'nuxt_plugin_polyFill_b2245196' // Source: ../plugins/polyFill (mode: 'all')
import nuxt_plugin_messaging_5683d804 from 'nuxt_plugin_messaging_5683d804' // Source: ../plugins/messaging (mode: 'all')
import nuxt_plugin_auth_55a16724 from 'nuxt_plugin_auth_55a16724' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_profile_c16f45ba from 'nuxt_plugin_profile_c16f45ba' // Source: ../plugins/profile (mode: 'all')
import nuxt_plugin_mixins_5a60d958 from 'nuxt_plugin_mixins_5a60d958' // Source: ../plugins/mixins (mode: 'all')
import nuxt_plugin_eventTracker_4f250404 from 'nuxt_plugin_eventTracker_4f250404' // Source: ../plugins/eventTracker (mode: 'all')
import nuxt_plugin_scrollPosition_314bf65c from 'nuxt_plugin_scrollPosition_314bf65c' // Source: ../plugins/scrollPosition (mode: 'all')
import nuxt_plugin_tracking_5d8a8b06 from 'nuxt_plugin_tracking_5d8a8b06' // Source: ../plugins/tracking (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"link":[{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Ffavicon-16x16.png","rel":"icon","sizes":"16x16","type":"image\u002Fpng"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Ffavicon-32x32.png","rel":"icon","sizes":"32x32","type":"image\u002Fpng"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Ffavicon-96x96.png","rel":"icon","sizes":"96x96","type":"image\u002Fpng"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fandroid-icon\u002Fandroid-icon-192x192.png","rel":"icon","sizes":"192x192","type":"image\u002Fpng"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-57x57.png","rel":"apple-touch-icon","sizes":"57x57"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-60x60.png","rel":"apple-touch-icon","sizes":"60x60"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-72x72.png","rel":"apple-touch-icon","sizes":"72x72"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-76x76.png","rel":"apple-touch-icon","sizes":"76x76"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-114x114.png","rel":"apple-touch-icon","sizes":"114x114"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-120x120.png","rel":"apple-touch-icon","sizes":"120x120"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-144x144.png","rel":"apple-touch-icon","sizes":"144x144"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-152x152.png","rel":"apple-touch-icon","sizes":"152x152"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fapple-icon\u002Fapple-icon-180x180.png","rel":"apple-touch-icon","sizes":"180x180"},{"href":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fmanifest.json","rel":"manifest"},{"crossorigin":"","href":"https:\u002F\u002Fapi.moovup.com","rel":"dns-prefetch"},{"crossorigin":"","href":"https:\u002F\u002Fassets.moovup.com","rel":"dns-prefetch"},{"crossorigin":"","href":"https:\u002F\u002Fa.moovup.com","rel":"dns-prefetch"},{"crossorigin":"","href":"https:\u002F\u002Fwww.googletagmanager.com","rel":"dns-prefetch"},{"crossorigin":"","href":"https:\u002F\u002Fwww.google-analytics.com","rel":"dns-prefetch"},{"href":"https:\u002F\u002Fapi.moovup.com","rel":"preconnect"},{"href":"https:\u002F\u002Fassets.moovup.com","rel":"preconnect"},{"href":"https:\u002F\u002Fa.moovup.com","rel":"preconnect"},{"href":"https:\u002F\u002Fwww.googletagmanager.com","rel":"preconnect"},{"href":"https:\u002F\u002Fwww.google-analytics.com","rel":"preconnect"}],"meta":[{"charset":"utf-8"},{"content":"IE=edge","http-equiv":"X-UA-Compatible"},{"content":"width=device-width, initial-scale=1","name":"viewport"},{"content":"香港免費前線招聘求職平台，招聘兼職part-time、全職full-time、臨時工、包裝員、文員、倉務員超過4,000份前線職位空缺。餐飲、零售、物流、運輸、包裝生產、活動推廣及客戶服務等行業正在招聘的工作，更可建立你的網上電子履歷表及求職喜好，方便職位配對及接收最新職缺通知。搵工網、搵工app同時適用，立即開始於Moovup好工速遞搵工。","hid":"description","name":"description"},{"content":"job, jobs, job search, find job, post job, work, 搵工, 求職, 招聘, 工作, recruit, recruitment, jobseekers, employment, employment agency, employer, employee, part time, full time, 求職網, 搵工網, 職位空缺, 全職, 兼職, 履歷表, career news, resume, cover letter, CV sample","hid":"keywords","name":"keywords"},{"content":"yes","name":"mobile-web-app-capable"},{"content":"yes","name":"apple-mobile-web-app-capable"},{"content":"#fefeff","name":"theme-color"},{"content":"app-id=1215492885","name":"apple-itunes-app"},{"content":"#fefeff","name":"msapplication-TileColor"},{"content":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fms-icon\u002Fms-icon-144x144.png","name":"msapplication-TileImage"},{"content":"1815431655452187","property":"fb:app_id"},{"content":"Moovup","property":"og:site_name"},{"content":"website","property":"og:type"},{"content":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fshare-link-img.png","hid":"og:image:0","property":"og:image"},{"content":"image\u002Fpng","property":"og:image:type"},{"content":"1024","property":"og:image:width"},{"content":"536","property":"og:image:height"},{"content":"summary_large_image","name":"twitter:card"},{"content":"https:\u002F\u002Fmoovup.com\u002Fhk\u002Fimg\u002Fshare-link-img.png","hid":"twitter:image","name":"twitter:image"}],"script":[{},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-CQ0178YFFX","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"title":"香港免費前線招聘求職平台 | Moovup好工速遞","style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_7b8a2475 === 'function') {
    await nuxt_plugin_googlegtag_7b8a2475(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_e471faa8 === 'function') {
    await nuxt_plugin_pluginclient_e471faa8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_18ff1798 === 'function') {
    await nuxt_plugin_pluginserver_18ff1798(app.context, inject)
  }

  if (typeof nuxt_plugin_screenDetect_4bb1ca16 === 'function') {
    await nuxt_plugin_screenDetect_4bb1ca16(app.context, inject)
  }

  if (typeof nuxt_plugin_polyFill_b2245196 === 'function') {
    await nuxt_plugin_polyFill_b2245196(app.context, inject)
  }

  if (typeof nuxt_plugin_messaging_5683d804 === 'function') {
    await nuxt_plugin_messaging_5683d804(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_55a16724 === 'function') {
    await nuxt_plugin_auth_55a16724(app.context, inject)
  }

  if (typeof nuxt_plugin_profile_c16f45ba === 'function') {
    await nuxt_plugin_profile_c16f45ba(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5a60d958 === 'function') {
    await nuxt_plugin_mixins_5a60d958(app.context, inject)
  }

  if (typeof nuxt_plugin_eventTracker_4f250404 === 'function') {
    await nuxt_plugin_eventTracker_4f250404(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollPosition_314bf65c === 'function') {
    await nuxt_plugin_scrollPosition_314bf65c(app.context, inject)
  }

  if (typeof nuxt_plugin_tracking_5d8a8b06 === 'function') {
    await nuxt_plugin_tracking_5d8a8b06(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
